import axios from 'axios'
import * as ConstantsBase from '../Constants/base'
import { environmentConfig } from '../Utility/Utility'

export const CleanersAdminAddCleaner = async (AuthData,UserId,AuthStr) => {
    const getUrl = environmentConfig();
    const requestUrl = getUrl + ConstantsBase.AddCleanerSchedule+UserId
  
    try {
      const data = await axios({
        method: 'post',
        url: requestUrl,
         data: AuthData,
        headers: { 'Content-Type': 'application/json;' ,Authorization :AuthStr},
        validateStatus: function (status) { return status >= 200 }
      })
      return data;
    }
  
    catch (e) {
      return e;
    }
  }